module.exports = __webpack_public_path__ + "static/media/nctu_gpa_rule.620650e3.PNG";